module.exports = __webpack_public_path__ + "static/preview-1-94c7417e404bcb23d7bcbfe68f8ffca6.png";